// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3VGuh","fileBtn":"File_fileBtn__i5tqM","closeBtn":"File_closeBtn__mjGQb","fileSelected":"File_fileSelected__ZkczO","disabled":"File_disabled__1ZsWt"};